import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token.service';

@Injectable({
        providedIn: 'root'
})
export class Groupsservice {
        header: any = ''
        constructor(public http: HttpClient,private tokenStorageService:TokenStorageService) { }
        async saveECGroups(obj) {
            let body = {
                        target: "saveECGroups",
                        source: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async getAllECGroups(obj) {
            let body = {
                        target: "getECGroups",
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async getAllECSubGroups(obj) {
            let body = {
                        target: "getECSubGroups",
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async getAllWorkflows(obj) {
            let body = {
                        target: "getECForms",
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async saveEcForm(obj) {
            let body = {
                        target: "saveECForms",
                        source: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async saveECSubGroups(obj) {
            let body = {
                        target: "saveECSubGroups",
                        source: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async updateForms(regData, selectedUUID) {
                let obj = {
                        uuid: selectedUUID,
                        group: regData.group
                }
            let body = {
                        target: "updateECForms",
                        source: regData,
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async updateECSubGroups(regData, selectedUUID) {
                let obj = {
                        uuid: selectedUUID
                }
            let body = {
                        target: "updateECSubGroups",
                        source: regData,
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
        async updateECGroups(regData, selectedUUID) {
                let obj = {
                        groupId: selectedUUID
                }
            let body = {
                        target: "updateECGroups",
                        source: regData,
                        query: obj,
                        lKey: "eCommerce"
                }
              return new Promise((resolve, reject) => {
                        this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
                                console.log("result", result);
                                resolve(result)
                        }, reject);
                })
        }
}